import { ReactNode } from 'react';

import { StringKey } from '../../../lang/index';
import { AppFormattedMessage } from '../../app-formatted-message/index';

export enum ApproveHurdleColumn {
  APPROVAL_DATE = 'approval-date',
  CURRENT_VALUATION = 'current-valuation',
  GRANT = 'grant',
  HURDLE = 'hurdle',
  ISSUED_SHARES = 'issued-shares',
  SELECT = 'select',
  SHARE_CLASS = 'share-class',
  STAKEHOLDER = 'stakeholder',
}

export const approveHurdleColumnTitle: Record<ApproveHurdleColumn, ReactNode | StringKey> = {
  [ApproveHurdleColumn.SELECT]: <AppFormattedMessage id="EMPTY" />,
  [ApproveHurdleColumn.STAKEHOLDER]: <AppFormattedMessage id="STAKEHOLDER" />,
  [ApproveHurdleColumn.GRANT]: <AppFormattedMessage id="GRANT" />,
  [ApproveHurdleColumn.APPROVAL_DATE]: <AppFormattedMessage id="APPROVAL_DATE" />,
  [ApproveHurdleColumn.SHARE_CLASS]: <AppFormattedMessage id="SHARE_CLASS" />,
  [ApproveHurdleColumn.HURDLE]: <AppFormattedMessage id="HURDLE" />,
  [ApproveHurdleColumn.CURRENT_VALUATION]: <AppFormattedMessage id="CURRENT_VALUATION" />,
  [ApproveHurdleColumn.ISSUED_SHARES]: <AppFormattedMessage id="ISSUED_SHARES" />,
};

export const approveHurdleColumnMap = Object.keys(approveHurdleColumnTitle);

export enum ApproveTargetBasedColumn {
  APPROVAL_DATE = 'approval-date',
  GRANT = 'grant',
  ISSUED_SHARES = 'issued-shares',
  PLAN_TYPE = 'plan-type',
  SELECT = 'select',
  SHARE_CLASS = 'share-class',
  STAKEHOLDER = 'stakeholder',
  TARGET_DATE = 'target-date',
  TARGET_NAME = 'target-name',
}

export const approveTargetBasedColumnTitle: Record<ApproveTargetBasedColumn, ReactNode | string> = {
  [ApproveTargetBasedColumn.SELECT]: '',
  [ApproveTargetBasedColumn.STAKEHOLDER]: 'Stakeholder',
  [ApproveTargetBasedColumn.GRANT]: 'Grant',
  [ApproveTargetBasedColumn.APPROVAL_DATE]: 'Approval Date',
  [ApproveTargetBasedColumn.SHARE_CLASS]: 'Share Class',
  [ApproveTargetBasedColumn.PLAN_TYPE]: 'Plan Type',
  [ApproveTargetBasedColumn.TARGET_NAME]: 'Target Name',
  [ApproveTargetBasedColumn.TARGET_DATE]: 'Target Date',
  [ApproveTargetBasedColumn.ISSUED_SHARES]: 'Issued Shares',
};

export const approveTargetBasedColumnMap = Object.keys(approveTargetBasedColumnTitle);
